export const versions = ['144', '360', '480', '640', '720', '800', '1080', '1200'];
